import Box from '~/core/Box'
import Link from '~/core/Link'
import getColor from '~/lib/getColor'

import { FOOTER_LINKS } from './constants'

import { PLACEMENT } from '.'

export default function DrawerFooter() {
    return (
        <Box
            backgroundColor="blackAlpha02"
            justifyContent="around"
            padding="8px 0px"
            style={{
                boxShadow: `0px 1px 0px 0px ${getColor('blackAlpha15')} inset`,
            }}
        >
            {FOOTER_LINKS.map(({ id, name, link }) => (
                <Link
                    data-test-target={`${id}-${PLACEMENT}`}
                    href={link}
                    key={id}
                    name={id}
                    style={{ fontSize: '11px' }}
                    target="_blank"
                    placement={PLACEMENT}
                >
                    {name}
                </Link>
            ))}
        </Box>
    )
}
